import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

const BgImg = ({ alt, sizes, resolutions, height, top, left }) => {
  return (
    <Img
      alt={alt}
      resolutions={resolutions || null}
      sizes={sizes || null}
      style={{
        position: 'absolute',
        left: left || 0,
        top: top || 0,
        width: '100%',
        height: height,
        zIndex: -1,
      }}
    />
  );
};

BgImg.propTypes = {
  alt: PropTypes.string.isRequired,
  resolutions: PropTypes.object,
  sizes: PropTypes.object,
  height: PropTypes.number.isRequired,
  top: PropTypes.string,
  left: PropTypes.string,
};

export default BgImg;



// WEBPACK FOOTER //
// ./src/components/ui/img/BgImg.js